// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const SearchIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Search",
    children: /*#__PURE__*/_jsx("path", {
      d: "m29.66 27.7-8.36-8.36c1.4-1.8 2.24-4.09 2.24-6.58C23.54 6.82 18.72 2 12.78 2S2.01 6.82 2.01 12.76s4.82 10.76 10.76 10.76c2.49 0 4.78-.84 6.6-2.26l-.02.02 8.34 8.36c.24.22.57.36.92.36.76 0 1.38-.62 1.38-1.38 0-.36-.14-.68-.36-.93s.03 0 .03 0Zm-16.84-6.94c-4.4 0-7.96-3.58-7.96-7.97s3.57-7.97 7.97-7.97 7.97 3.57 7.97 7.97v.03c-.02 4.39-3.59 7.95-7.98 7.95Z"
    })
  });
};